export default {
  hubs: {
    description: 'Hubs are an essential part of keeping your routine under control.',
    infoBlock: {
      firstMonthFree: 'First month free',
      freeUntil: 'Free trial until ',
      activeUntil: 'Active until',
    },
    price: {
      free: 'Free',
    },
    hubsInfo: {
      profile: {
        label: 'Profile',
        description:
          'Access your family contact information, appearance, and body art quickly. Strengthen family bonds and build a sense of connection.',
      },
      backlog: {
        label: 'Backlog',
        description:
          'Achieve goals without time limits. Now you can easily list and prioritize extremely urgent tasks with no particular due date.',
      },
      roadmap: {
        label: 'Roadmap',
        description:
          'Create a clear and visualized strategy to achieve the goal and conveniently manage tasks demonstrating each stage on the way to it.',
      },
      planner: {
        label: 'Journal',
        description:
          'Transform your life with an easy-to-use scheduling system for your appointments and daily tasks.',
      },
      archive: {
        label: 'Archive',
        description: 'Declutter your current, completed or unfinished tasks and events by archiving them.',
      },
      calendar: {
        label: 'Calendar',
        description:
          'Enjoy the benefits of planning your routine in an unusual visual calendar format and achieve your goals.',
      },
      events: {
        label: 'Events',
        description:
          'Get rid of the stress associated with organizing offline and online meetings. Instead, efficiently plan and manage events and meetings.',
      },
      garage: {
        label: 'Garage hub',
        description:
          'Get quick access to any information about your vehicle. With hubmee, you will make your car last longer.',
      },
      education: {
        label: 'Education hub',
        description:
          'Improve your learning skills and study effectively. Suits both university students and those who joined courses.',
      },
      pets: {
        label: 'Pets hub',
        description:
          'Take care of your pets as they deserve it. Suits both newbies and experienced pet owners.',
      },
      health: {
        label: 'Health hub',
        description:
          'Health tracking is the best way to follow a healthy lifestyle. Add any small detail about your bodys well-being.',
      },
      budget: {
        label: 'Budget hub',
        description:
          'Create financial stability. Pay your bills on time by tracking expenses and following a plan.',
      },
      property: {
        label: 'Property hub',
        description:
          'Take everything in your house under control. Structurize Utility Services and track all future payments.',
      },
      work: {
        label: 'Work hub',
        description:
          "Track your career growth with hubmee. Suits cases when you're job hunting or want to add structure to your current work.",
      },

      storage: {
        label: 'Storage',
        description:
          'Easily interact with all files previously uploaded to hubmee and monitor the amount of memory used.',
      },
      googleSync: {
        label: 'Google Sync',
        description:
          'Daily planning is now more innovative than ever: enjoy full synchronization of tasks and events with your Google calendar.',
      },
    },
    hubsInfoModalContainers: {
      garage: {
        title1: 'Make car payments on time',
        description1:
          'Let us take care of your car insurance and oil change. Every next payment will appear as a part of your schedule. So, all you have to do is to fill your vehicle information in and enjoy living your best life!',
        title2: 'Quick access to the car information',
        description2:
          'In Garage Hub, you can add ANY small detail about your car. From your vehicle and license plate stickers to general information. Save a lot of time by having access to your car data in one click.',
        title3: 'Share easily',
        description3:
          'One car for a family is a great idea, especially when each family member has quick access to vehicle information for every occasion of life. You can share here your car details with your family and be sure about your personal data safety because we care about your privacy. What you add in hubmee - stays in hubmee.',
        title4: 'License and Vehicle Stickers',
        description4:
          'The best thing you can do for your inner calm is to fill in the main information about your License and Vehicle Plates Stickers here. So a busy schedule won’t be the reason to forget mandatory car payments. Or even worse - get fined. You’ll finally feel relief when things get done quickly and on time.',
        title5: 'Stickers/License Plates Renewal:',
        description5:
          "Other exciting features are Vehicle and License Plates Stickers . In case you need to buy a special sticker in order to park in a specific area near your house, it is crucial to regularly update these stickers and license plates to avoid getting fined. Let hubmee take over! You will receive a notification when it's time to update any of these items.",
      },
      profile: {
        title1: 'Сontact information',
        description1:
          'Let your colleagues contact you quickly and easily. Add your contact information, such as phone number, email, and home address. It will help your colleagues reach out to you for work-related communication and collaboration. Don’t worry, this information is visible only to people added to your Network. So only you choose who can see all of it.',
        title2: 'Body art information',
        description2:
          'Got any tattoos or piercings? Fill in general information, such as: salon, artist, and price. Quick access to salon and artist contacts will help schedule future appointments or reach out to the master to know more about aftercare.',
        title3: 'Appearance',
        description3:
          'Now, you don’t have to remember every tiny detail about your family and friends. Find everything you need in their hubmee profiles. It works the same way for your friends and family members. Knowing your clothing size, eye color, and preferred styles will help your loved ones choose gifts you will appreciate.',
        title4: 'General information',
        description4:
          'Access your ID, driver`s license, and other important documents quickly by adding them to your profile. Your general information will also be helpful for hubmee to collect all needed data and treat you right, according to your preferences, date of birth, and relationship status. If these data don’t bother you - it tells us about you a lot, too.',
      },
    },
  },
};
